import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=4bf6621f&v=3"
import script from "./Table.vue?vue&type=script&lang=js&v=3"
export * from "./Table.vue?vue&type=script&lang=js&v=3"
import style0 from "./Table.vue?vue&type=style&index=0&id=4bf6621f&prod&lang=css&v=3"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports